import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api, ApiError } from '../api/client';
import { SALES_RESOURCES_VERSION, salesResourcesForRole } from '../content/salesResourcesContent';
import { useProgress } from '../state/ProgressContext';
import { isHvacPosition } from '../content/positions';
import { HvacOnboardingSteps } from '../components/HvacOnboardingSteps';

export function SalesResources() {
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();
  const { progress, refresh } = useProgress();
  // A field applicant and a remote applicant need different things on day one - the field
  // list drops the VoIP calling number they are never issued and adds the flyer, QR code,
  // live demo line, discovery questions and objection guide they actually carry on a visit.
  const resources = salesResourcesForRole(progress?.roleId);

  async function complete() {
    setSubmitting(true); setError(null);
    try {
      if (!progress?.flags.salesResourcesDone) {
        await api.post('/api/application/sales-resources/complete', { version: SALES_RESOURCES_VERSION });
        await refresh();
      }
      navigate('/onboarding/agreement');
    } catch (e) { setError(e instanceof ApiError ? e.message : 'Could not save your confirmation.'); }
    finally { setSubmitting(false); }
  }

  if (progress && isHvacPosition(progress.roleId)) {
    return <div><h1 className="step-title">Accept the position</h1><p className="step-subtitle">You were approved. Here is what you are accepting and what Krovance gives you.</p>
      <HvacOnboardingSteps progress={progress} />
      <div className="resource-card-grid">{resources.map((item) => <section className="card" key={item.title}><h2>{item.title}</h2><p>{item.body}</p></section>)}</div>
      <div className="card">{error && <div className="alert error">{error}</div>}<button className="btn-primary" disabled={submitting} onClick={complete}>{submitting ? 'Saving…' : progress.flags.salesResourcesDone ? 'Continue to the contractor agreement' : 'Accept the position and continue'}</button></div>
    </div>;
  }
  return <div><h1 className="step-title">What Krovance Provides Sales Representatives</h1><p className="step-subtitle">Review these onboarding resources before opening your contractor agreement.</p>
    <div className="resource-card-grid">{resources.map((item) => <section className="card" key={item.title}><h2>{item.title}</h2><p>{item.body}</p></section>)}</div>
    <div className="card">{error && <div className="alert error">{error}</div>}<button className="btn-primary" disabled={submitting} onClick={complete}>{submitting ? 'Saving…' : 'Continue to Contractor Agreement'}</button></div>
  </div>;
}
